export function parseAppointmentData({ appointmentData }) {
    const user_address = appointmentData.appointment_address;
    const appointmentPayload = {
        zip_code: user_address.address.postal_code,
        items: [],
        appointment_date: appointmentData.appointment_date_id,
        appointment_hour_slot_id: appointmentData.appointment_hour_slot_id,
        appointment_address: null,
        payment: {
            is_new: false,
            payment_token: appointmentData.payment.id,
            total: 0,
            coupon: ''
        }
    };

    if (user_address.id < 0) {
        appointmentPayload.appointment_address = {
            info: user_address.address,
            location: user_address.location
        }
    } else {
        appointmentPayload.appointment_address = {
            id: user_address.id,
            info: user_address.address,
            location: user_address.location
        }
    }

    let total = 0;

    appointmentData.items.forEach(device => {
        const newDevice = { device_id: device.id, device_color_id: device.color.id, issues: [] };
        device.issues.forEach(issue => {
            total += issue.price;
            newDevice.issues.push({ id: issue.id, other_text: '', price: issue.price });
        });
        appointmentPayload.items.push(newDevice)
    });

    appointmentPayload.payment.total = total;

    return appointmentPayload;
}
